/* eslint-disable no-undef */

import 'phaser';
import { Button } from "./../Entities/GlobalEntities"
import { AddImageToScene, getRandomInt, loadImage } from "./../modules/utiltes"
export class SceneIntro extends Phaser.Scene {
    constructor() {
        super({
            key: 'SceneIntro',
        });
    }

    init(data) {
        // Access the mode parameter passed from Scene 1
        this.mode = data.mode;
    }

    preload() {
        loadImage(this, 'deepspaceintro', 'assets/img/game/Background-1.png')
        loadImage(this, 'starmissiontbtn', 'assets/img/game/StartMission.png')
        loadImage(this, 'loadingscene', `assets/img/game/BG ${getRandomInt(19)}.jpg`)

    }

    create() {
        this.bg = AddImageToScene(this, 'deepspaceintro')
        const div = document.createElement('div');
        div.innerHTML = `<p
        class="sceneInfo"
    />
    Greetings Commander,
    <br/>
    As a member of the SafeMoon Defenders Force (SFM-DF), you are our last and only hope to defend the moon base and rebuild Earth!
    <br/>
    <br/>
    The mission will take place in the 100MM area before MArs moon PHOBOS.
    <br/>
    <br/>
    These create an impossible situation to support your mission with ammunition supplies or reinforcements.
    <br/>
    <br/>
    You have to be thoughtful when choosing your targets, and once you decided on an objective, shoot with your laser cannons. Our intel will be late due to the Mars colony destruction, ignore any signals as they will be a trap
    <br/>
    <br/>
    Remember Commander that your ship has been retrofitted with slipstream engines allowing you to be flying at supercruise speed. The catch is that you can not restart the engine, if you stop you are dead! So there’s no reason to eliminate all the targets in space, you still keep control of your spaceship to pitch and yaw during supercruise.
    <br/>
    <br/>
    I wish you good luck on your mission, and god bless the federation with your success.
    <br/>
    Leda Yrissem,
    <br/>
    Rear Admiral Of The Federation
    <br/>
    <br/>
    Pitch/Yaw: [&#8593;] [&#8595;] [&#8592;] [&#8594;] - Fire: [SPACEBAR]- Sheild Activation: [SHIFT] - RepaireKit Activation: [CTRL] - Shield slider Right :[Z] - Shield slider Left :[X]- Weapon slider Right :[C] - Weapon slider Left :[V] - Self Destruction :[S]
    </p>
    <br></br>`;
        this.starmissiontbtn = new Button(
            this,
            250,
            620,
            "starmissiontbtn"

        )
        this.starmissiontbtn.setInteractive()
        this.starmissiontbtn.on('pointerdown', function(pointer) {

            this.setTint(0x6B128B);

        });
        this.starmissiontbtn.on('pointerup', (pointer) => {

            this.scene.start('loadingscene', { mode: this.mode })

        });
        this.starmissiontbtn.on('pointerout', function(pointer) {

            this.clearTint();

        });
        this.add.dom(this.game.config.width * 0.3, this.game.config.height * 0, div, 'background-color: transparent; width: 220px; height: 0; font: 30px Arial');
    }
}